export default __webpack_public_path__ + "static/media/logo.8795e37e.svg";